import { createComponent } from 'solid-js/web';
import { mergeProps, createContext, createComputed, useContext } from 'solid-js';
import { createMutable, createStore } from 'solid-js/store';
import { DEFAULT_INTL_CONFIG, createIntlCache, createIntl } from '@formatjs/intl';
export { defineMessage, defineMessages } from '@formatjs/intl';

function processConfig(config) {
  return mergeProps(DEFAULT_INTL_CONFIG, {
    locale: config.locale,
    timeZone: config.timeZone,
    fallbackOnEmptyString: config.fallbackOnEmptyString,
    formats: config.formats,
    messages: config.messages,
    defaultLocale: config.defaultLocale,
    defaultFormats: config.defaultFormats,
    defaultRichTextElements: config.defaultRichTextElements,
    onError: config.onError,
    onWarn: config.onWarn
  });
}

const typeOf = value => ({}).toString.call(value).match(/\s([A-Za-z]+)/)?.[1].toLowerCase() ?? "";
var typeOf$1 = typeOf;

const is = {
  // @ts-ignore
  nullish(value) {
    return value === null || value === undefined;
  },
  // @ts-ignore
  string(value) {
    return typeOf$1(value) === "string";
  },
  // @ts-ignore
  number(value) {
    return typeOf$1(value) === "number";
  },
  // @ts-ignore
  bool(value) {
    return typeOf$1(value) === "boolean";
  },
  // @ts-ignore
  object(value) {
    return typeOf$1(value) === "object";
  },
  // @ts-ignore
  array(value) {
    return Array.isArray(value);
  },
  // @ts-ignore
  date(value) {
    return typeOf$1(value) === "date";
  },
  // @ts-ignore
  function(value) {
    return typeOf$1(value) === "function";
  }
};
var is$1 = is;

const IntlContext = createContext();
const IntlProvider = props => {
  if (is$1.nullish(props.locale)) {
    throw new ReferenceError('[solid-intl]: <IntlProvider /> expects a "locale" which was not configured. See https://formatjs.io/docs/react-intl/api#intlshape for more details');
  }
  const cache = createMutable(createIntlCache());
  const [intl, setIntl] = createStore(createIntl(processConfig(props), cache));
  createComputed(() => {
    setIntl(createIntl(processConfig(props), cache));
  });
  return createComponent(IntlContext.Provider, {
    value: intl,
    get children() {
      return props.children;
    }
  });
};
var IntlProvider$1 = IntlProvider;

const useIntl = () => {
  const intl = useContext(IntlContext);
  if (!intl) {
    throw new ReferenceError("[solid-intl]: Have you forgot to wrap your application with <IntlProvider /> ?");
  }
  return intl;
};
var useIntl$1 = useIntl;

export { IntlProvider$1 as IntlProvider, useIntl$1 as useIntl };
